module.exports = __webpack_public_path__ + "ffa5badd054f465bf879543954816c29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/16.jpg
// module id = 226
// module chunks = 0